<template>
  <BaseModal
    :id="'static-schedule-rooms'"
    :title="title"
    :size="'lg'"
  >
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template v-slot:content>
      <form class="col-12 p-0" @submit.prevent="scheduled_submit()">
        <FormDynamic
          :form_format="form_format"
          :form_data="form_data"
          :array_options="array_options"
          :for_update="false"
        />

        <hr/>
          <div class="modal-title w-100" v-show="room_tasks.length">
            <h2 class="title--1" v-html="'Rooms'"/>
          </div>
          <div class="row mb-0 no-gutters">
            <div class="col-md-12" style="margin-top:10px;">
              <v-card>
                <DinamicTableInfiniteLoader
                    :selectable_columns="false"
                    name="AdvancedSearch"
                    :link="'/building-room/'"
                    :headers="table_headers"
                    :items="room_tasks"
                    :pagination="pagination"
                    :checkable="true"
                    :size="30"
                    :historiable="false"
                    :updateable="false"
                    @paginateMoreRecords="paginateMoreRecords($event)"
                    ref="main_table"
                />
              </v-card>
            </div>
          </div>
        <hr/>
        <CentralButtons v-show="room_tasks.length"/>
      </form>
    </template>
  </BaseModal>
</template>

<script>

import FormResources  from './form_resources'
import FormDynamic    from '@/components/FormDynamic.vue'
import Breadcrumb     from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal      from '@/components/BaseModal'
import CentralButtons from '@/components/CentralButtons'
import Resources      from './resources'
import DinamicTableInfiniteLoader   from '@/components/DinamicTableInfiniteLoader'

export default {

  name: "ScheduledFormModal",

  props: [
    'title',
    'rest_api',
    'notyf',
    'array_options',
    'breadcrumb',
		'scheduled_current_date',
  ],

  components:{
    FormDynamic,
    Breadcrumb,
    BaseModal,
    CentralButtons,
		DinamicTableInfiniteLoader,
  },

  data(){
    return{
      table_headers: Resources.scheduled_table_headers,
      form_data:   FormResources.scheduled_form_data,
      form_format: FormResources.scheduled_form_format,
      form_backup: {...FormResources.scheduled_form_data},
			room_tasks: [],
      search: '',
      rest_api_search: this.rest_api + '/search_room_tasks',
      rest_api_pagination: `${this.rest_api}_pagination`,
      pagination: null,
    }
  },

  watch: 
  {
    form_data: 
    {
      handler(val)
      {
          let keys = Object.keys(val);
          
          keys.forEach(item => 
          {
              this.$refs.main_table.params[item] = val[item]
          });

          this.$refs.main_table.params['page'] = 1;
          this.fetchMainList(this.$refs.main_table.params)
      },
      deep: true
    },

    async 'form_data.building_id'(val)
    {
      if(val)
      {
        let http_request = {
            building_id: val,
        }
        this.loader(true)               
        const response = await this.post(`${this.rest_api_search}`, http_request)
        if(response.status)
        {
          if(response.data?.levels?.length)
          {
            this.array_options['level_id'] = response.data.levels
            this.array_options['task_id'] = response.data.project_tasks
            this.form_data.level_id = ''
            this.form_data.area_id = ''
            this.notyf.success('Levels available')
          }
          else
          {
            this.array_options['level_id'] = []
            this.array_options['area_id'] = []
            this.array_options['task_id'] = []
            this.form_data.level_id = ''
            this.form_data.area_id = ''
            this.notyf.error('No Levels available')
          }

					this.loader()
        }
        else
        {
          this.error_handling(response)
					this.loader()
        }
      }
    },

    async 'form_data.level_id'(val)
    {
      if(val)
      {
        let http_request = {
          level_id: val,
        }
       
        this.loader(true)
        const response = await this.post(`${this.rest_api_search}`, http_request)
        if(response.status)
        {
          if(response.data?.areas?.length)
          {
            this.array_options['area_id'] = response.data.areas
            this.form_data.area_id = ''
            this.notyf.success('Areas available')
          }
          else
          {
            this.array_options['area_id'] = []
            this.form_data.area_id = ''
            this.notyf.error('No areas available')
          }

					this.loader()
        }
        else
        {
          this.error_handling(response)
					this.loader()
        }
      }
    },

    async 'form_data.area_id'(val)
    {
      if(val)
      {
        let http_request = {
          area_id: val,
        }
        this.loader(true)
        const response = await this.post(`${this.rest_api_search}`, http_request)

        if(response.status)
        {   
					this.loader()
        }
        else
        {
          this.error_handling(response)
					this.loader()
        }
      }
    },
  },

  methods: {

    scheduled_submit()
    {
      let rooms_filtered = this.returnedRoomsToParent();

      rooms_filtered.unchecked_items = rooms_filtered.unchecked_items.map(item => item.room_task_id)

      this.post_request(rooms_filtered)
    },

    returnedRoomsToParent()
    {
        if(this.room_tasks.length)
        {
            return {...this.$refs.main_table.returnSelection(),  params: this.$refs.main_table.params}
        }
        return null
    },

    async post_request(request)
    {
      this.loader(true)

      let response = await this.post(this.rest_api, request)

      if(response.status)
      {
        this.notyf.success('Success')
        this.rooms = [];
        this.form_data = {...this.form_backup};
        window.$('#static-schedule-rooms').modal('hide')
        this.loader();
      }
      else
      {
        this.loader()
        this.error_handling(response)
      }
    },

    async paginateMoreRecords(params)
    {
      if(this.room_tasks.length >= this.pagination?.total)
      {
          return;
      }
      
      await this.showLoader()

      await this.apiRequest(params)
    },

    async fetchMainList(params) 
    {
        this.room_tasks = [];
        await this.showLoader()
        await this.apiRequest(params, true)
    },

    async loadMoreRecords(data, reset_list)
    {
        if(reset_list)
        {
            this.room_tasks = []
        }

        if(data.pagination.data.length)
        {
            data.pagination.data.forEach((item) => {
                item.checked = this.$refs.main_table.select_all
                this.room_tasks.push(item)
            })
        }
        this.pagination = data.pagination

        this.$emit('passData', data.options || null)

        await this.hideLoader(data.pagination.data)
    },

    async showLoader()
    {
        this.$refs.main_table.showLoader()
    },

    async hideLoader(data)
    {
        this.$refs.main_table.hideLoader(data)
    },

    async initialSetup()
    {
      this.$refs.main_table.select_all = false
      this.room_tasks = []
      await this.paginateMoreRecords({page: 1})
    }


	},

  mounted() 
  
  {
  },
  
};
</script>